export const ANALYSES_REQUEST = "analyses-request";
export const ANALYSES_REQUEST_SUCCESS = "analyses-request-success";
export const ANALYSES_REQUEST_ERROR = "analyses-request-error";
export const CLEANUP = 'cleanup';

export const CREATE_ANALYSIS_REQUEST = "create-analysis-request";
export const CREATE_ANALYSIS_SUCCESS = "create-analysis-success";
export const CREATE_ANALYSIS_FAILURE = "create-analysis-failure";

export const DELETE_ANALYSIS_FAILURE = "delete-analysis-failure";

export const FETCHING_AREA_EXPANSION_DTO = 'fetching-area-expansion-dto';
export const FETCH_AREA_EXPANSION_DTO_SUCCESS = 'fetch-area-expansion-dto-success';
export const FETCH_AREA_EXPANSION_DTO_FAILED = 'fetch-area-expansion-dto-failed';

export const FETCHING_YIELD_BY_YEAR_DTO = 'fetching-yield-by-year-dto';
export const FETCH_YIELD_BY_YEAR_DTO_SUCCESS = 'fetch-yield-by-year-dto-success';
export const FETCH_YIELD_BY_YEAR_DTO_FAILED = 'fetch-yield-by-year-dto-failed';

export const FETCH_COMPARATIVE_SCORE_REQUEST = 'fetch-comparative-score-request';
export const FETCH_COMPARATIVE_SCORE_SUCCESS = 'fetch-comparative-score-success';
export const FETCH_COMPARATIVE_SCORE_FAILED = 'fetch-comparative-score-failed';

export const FETCH_ANALYSIS_SUMMARY_REQUEST = 'fetch-analysis-summary-request';
export const FETCH_ANALYSIS_SUMMARY_SUCCESS = 'fetch-analysis-summary-success';
export const FETCH_ANALYSIS_SUMMARY_FAILED = 'fetch-analysis-summary-failed';

export const FETCH_ANALYSIS_YIELD_EVOLUTION_REQUEST = 'fetch-analysis-yield-evolution-request';
export const FETCH_ANALYSIS_YIELD_EVOLUTION_SUCCESS = 'fetch-analysis-yield-evolution-success';
export const FETCH_ANALYSIS_YIELD_EVOLUTION_FAILED = 'fetch-analysis-yield-evolution-failed';

export const FETCH_LAST_YEAR_YIELD_REQUEST = 'fetch-last-year-yield-request';
export const FETCH_LAST_YEAR_YIELD_SUCCESS = 'fetch-last-year-yield-success';
export const FETCH_LAST_YEAR_YIELD_FAILED = 'fetch-last-year-yield-failed';

export const FETCH_ANALYSIS_CROPS_STAGES_REQUEST = 'fetch-analysis-crops-stages-request';
export const FETCH_ANALYSIS_CROPS_STAGES_SUCCESS = 'fetch-analysis-crops-stages-success';
export const FETCH_ANALYSIS_CROPS_STAGES_FAILED = 'fetch-analysis-crops-stages-failed';
